const draggable = {
  oDraggableObjs: null,
  initialize: () => {
    draggable.oDraggableObjs = document.querySelectorAll('.js-draggable');
    for (let i = 0; i < draggable.oDraggableObjs.length; i += 1) {
      draggable.createDraggable(draggable.oDraggableObjs[i]);
    }
  },
  createDraggable: (dragObj) => {
    const slider = dragObj;
    const nextBtn = dragObj.nextElementSibling;
    const prevBtn = dragObj.previousElementSibling;
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('active');
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('active');
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return; // stop the fn from running
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 3;
      slider.scrollLeft = scrollLeft - walk;

      draggable.checkDragScrollPos(slider, nextBtn, prevBtn);
    });

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        scrollLeft = slider.scrollLeft;
        slider.scrollLeft = scrollLeft + 50;
        draggable.checkDragScrollPos(slider, nextBtn, prevBtn);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        scrollLeft = slider.scrollLeft;
        slider.scrollLeft = scrollLeft - 50;
        draggable.checkDragScrollPos(slider, nextBtn, prevBtn);
      });
    }
  },
  checkDragScrollPos: (slider, nextBtn, prevBtn) => {
    if (slider.scrollLeft > 0) {
      prevBtn.classList.add('is-visible');
    } else if (prevBtn.classList.contains('is-visible')) {
      prevBtn.classList.remove('is-visible');
    }

    if ((slider.scrollLeft + slider.offsetWidth) < slider.scrollWidth) {
      nextBtn.classList.add('is-visible');
    } else if (nextBtn.classList.contains('is-visible')) {
      nextBtn.classList.remove('is-visible');
    }
  },
};
